// expo-file-system compatibility layer for SDK 54 migration
// Objetivo: evitar acceder a APIs no soportadas en web y proveer fallbacks seguros.

// En SDK 54, las propiedades documentDirectory/cacheDirectory viven en el path legacy
import * as FileSystem from 'expo-file-system/legacy'

const isWeb = typeof window !== 'undefined' && typeof document !== 'undefined'

// En web, expo-file-system no está soportado. Evitamos leer getters nativos y damos defaults.
export const documentDirectory = isWeb
    ? '/'
    : (typeof FileSystem.documentDirectory !== 'undefined' ? FileSystem.documentDirectory : undefined)

export const cacheDirectory = isWeb
    ? '/tmp/'
    : (typeof FileSystem.cacheDirectory !== 'undefined' ? FileSystem.cacheDirectory : undefined)

// StorageAccessFramework no existe en web ni en SDK 54 (Android legacy). No-op seguro.
export const StorageAccessFramework = {
    requestDirectoryPermissionsAsync: (..._args) => Promise.resolve({ granted: false, directoryUri: '' }),
    createFileAsync: (..._args) => Promise.reject(new Error('StorageAccessFramework is unavailable')),
}

// EncodingType como strings estándar
export const EncodingType = {
    UTF8: 'utf8',
    Base64: 'base64',
}

// Re-export de funciones soportadas (no las uses en web salvo que tengas un polyfill propio)
// Desestructuramos en variables locales para poder "shim" funciones puntuales en web
const {
    copyAsync,
    createDownloadResumable,
    createUploadTask,
    deleteAsync,
    deleteLegacyDocumentDirectoryAndroid,
    downloadAsync,
    getContentUriAsync,
    getFreeDiskStorageAsync,
    getInfoAsync: FS_getInfoAsync,
    getTotalDiskCapacityAsync,
    makeDirectoryAsync,
    moveAsync,
    readAsStringAsync,
    readDirectoryAsync,
    uploadAsync,
    writeAsStringAsync,
} = FileSystem

export {
    copyAsync,
    createDownloadResumable,
    createUploadTask,
    deleteAsync,
    deleteLegacyDocumentDirectoryAndroid,
    downloadAsync,
    getContentUriAsync,
    getFreeDiskStorageAsync,
    getTotalDiskCapacityAsync,
    makeDirectoryAsync,
    moveAsync,
    readAsStringAsync,
    readDirectoryAsync,
    uploadAsync,
    writeAsStringAsync,
}

// En web devolvemos un stub seguro que evita excepciones y simplemente indica que el archivo no existe
export const getInfoAsync = isWeb
    ? async (path) => ({ exists: false, uri: typeof path === 'string' ? path : '' })
    : FS_getInfoAsync